<template>
    <fieldset class="w-full mb-3 tabs">
        <template v-for="(period, index) in periods">
            <input
                :key="`radio-${index}`"
                :id="`period-${index}`"
                type="radio"
                v-model="selected"
                :value="index"
                class="hidden"
            >
            <label
                :key="`label-${index}`"
                class="inline-block py-3 text-sm text-center capitalize select-none"
                :class="`w-1/${periods.length}`"
                :for="`period-${index}`"
            >
                {{ period.label }}
            </label>
        </template>
    </fieldset>
</template>

<script>
export default {
    props: {
        periods: Array,
        preSelected: String,
    },
    data() {
        return {
            selected: 0,
        }
    },
    mounted() {
        if (this.preSelected !== null) {
            this.periods.forEach((period, index) => {
                if (period.key === this.preSelected) {
                    this.selected = index
                }
            })
        }
    },
    watch: {
        selected() {
            this.$emit('change', this.periods[this.selected])
        },
    },
}
</script>

<style scoped>
    .tabs > input[type="radio"]:not(:checked) + label {
        @apply text-highlight-80 font-semibold cursor-pointer
    }

    .tabs > input[type="radio"]:checked + label {
        @apply text-highlight-100 font-bold border-b border-solid border-highlight-100;
    }
</style>
